<div *ngIf="schedules?.length > 0">
  <h3>{{scheduledItems}}:</h3>
</div>

<div *ngFor="let schedule of schedules">
  <p><strong>{{cycle}}: </strong>{{schedule.Cycle}}</p>
  <p *ngIf="schedule.Cycle != 'Daily'"><strong>{{day}}: </strong>{{schedule.Day}}</p>
  <p><strong>{{time}}: </strong>{{schedule.Time}}</p>
</div>
